import type { ReactNode } from "react";
import { GENRE_OPTIONS, REGION_OPTIONS, YEAR_RANGES } from "@/lib/catalog";

interface FilterPanelProps {
  genres: string[];
  regions: string[];
  years: string[];
  onToggleGenre: (value: string) => void;
  onToggleRegion: (value: string) => void;
  onToggleYear: (value: string) => void;
  onReset: () => void;
}

function Chip({
  label,
  active,
  onClick,
}: {
  label: string;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`rounded-full px-3 py-1 text-xs transition-colors whitespace-nowrap cursor-pointer ${
        active
          ? "bg-accent-500 text-foreground-950 font-medium"
          : "border border-background-700 text-foreground-300 hover:border-accent-500 hover:text-accent-400"
      }`}
    >
      {label}
    </button>
  );
}

function Group({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="border-b border-background-800 pb-5 last:border-b-0 last:pb-0">
      <h4 className="mb-3 font-heading text-sm font-bold text-foreground-100">{title}</h4>
      <div className="flex flex-wrap gap-2">{children}</div>
    </div>
  );
}

export default function FilterPanel({
  genres,
  regions,
  years,
  onToggleGenre,
  onToggleRegion,
  onToggleYear,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <span className="inline-flex items-center gap-2 font-heading text-sm font-bold text-foreground-100">
          <i className="ri-filter-3-line text-accent-400" />
          筛选条件
        </span>
        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center gap-1 text-xs text-secondary-300 transition-colors hover:text-accent-400 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-refresh-line" />
          重置
        </button>
      </div>

      <Group title="类型">
        {GENRE_OPTIONS.map((g) => (
          <Chip key={g} label={g} active={genres.includes(g)} onClick={() => onToggleGenre(g)} />
        ))}
      </Group>

      <Group title="地区">
        {REGION_OPTIONS.map((r) => (
          <Chip key={r} label={r} active={regions.includes(r)} onClick={() => onToggleRegion(r)} />
        ))}
      </Group>

      <Group title="年份">
        {YEAR_RANGES.map((y) => (
          <Chip key={y.id} label={y.label} active={years.includes(y.id)} onClick={() => onToggleYear(y.id)} />
        ))}
      </Group>
    </div>
  );
}